import React from 'react'

const ContratosArt = ({iconContactoMasculino}) => {
   return (
      <>
         <div className="bg-latitud animated fadeIn" style={{"margin-bottom": "30px"}}>
            <div className="container section center white-text">
               <h5>
                  <strong>Contratos ART (Jujuy y Salta)</strong>
               </h5>
            </div>
         </div>
         <div className="row">
            <div className="col s12 m12 l6 x6">
               <div className="card-panel grey lighten-5 z-depth-1">
                  <div className="row valign-wrapper">
                     <div className="col s2">
                        <img src={iconContactoMasculino} alt="" className="circle responsive-img"/> 
                     </div>
                     <div className="col s10">
                        <span className="black-text">
                           <strong>Cr. Facundo Albornoz</strong><br/>
                           0388 - 154 721 718<br/>
                           0388 - 4911741 Int.: 136<br/>
                           falbornoz@latitudsursa.com.ar
                        </span>
                     </div>
                  </div>
               </div>
            </div>
            <div className="col s12 m12 l6 x6">
               <div className="card-panel grey lighten-5 z-depth-1">
                  <div className="row valign-wrapper">
                     <div className="col s2">
                        <img src={iconContactoMasculino} alt="" className="circle responsive-img"/>
                     </div>
                     <div className="col s10">
                     <span className="black-text">
                        <strong>Luis Collado</strong><br/>
                        0388 - 154 711 767<br/>
                        0388 - 4911741 Int.: 132<br/>
                        lcollado@latitudsursa.com.ar
                     </span>
                     </div>
                  </div>
               </div>
            </div>
         </div>
         <div className="row">
            <div className="col s12 m12 l6 x6">
               <div className="card-panel grey lighten-5 z-depth-1">
                  <div className="row valign-wrapper">
                     <div className="col s2">
                        <img src={iconContactoMasculino} alt="" className="circle responsive-img"/>
                     </div>
                     <div className="col s10">
                        <span className="black-text">
                           <strong>Gabriel Correa</strong><br/>
                           0388 - 154 760 228<br/>
                           0388 - 4911741 Int.: 130<br/>
                           gcorrea@latitudsursa.com.ar
                        </span>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </>
   )
}

export default ContratosArt